var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-font-sans tw-ml-2 tw-shadow-md tw-inline-flex tw-justify-center tw-items-center tw-bg-success-300 tw-text-neutral-500 tw-rounded-full tw-text-center tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium"},[_vm._v(" New ")])}
var staticRenderFns = []

export { render, staticRenderFns }